import {
  makeStyles,
  Theme,
  IconButton,
  Typography,
  Button,
  createStyles,
} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';

import { Close } from '@material-ui/icons';
import React, { Props } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useIsMobile } from '../../../../util/style-utils';
import { Shadow } from '../../../../constants';
import colors from '../../../../themes/main-colors';
import BottomDrawerLayout, {
  DrawerSnapType,
} from '../bottom-drawer-layout/BottomDrawerLayout';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalWrapper: {
      display: 'flex',
      width: '593px',
      maxHeight: '77.21vh',
      flexDirection: 'column',
      position: 'absolute',
      top: '50%',
      left: '50%',
      overflow: 'auto',
      transform: 'translate(-50%, -50%)',
      padding: '20px',
      backgroundColor: colors.modalBackgroundColor,
      borderRadius: '5px',
      [theme.breakpoints.down('sm')]: {
        top: '50%',
        width: '90%',
        maxHeight: '90%',
        padding: theme.spacing(3),
      },
    },
    reconnectPopupStyles: {
      width: 'auto',
    },
    reconnectPopupStylesMobile: {
      width: '100%',
      marginTop: '1rem',
    },
    reconnectAnonymousCloseButton: {
      width: '120px',
      color: colors.sparkBlue,
    },
    ReconnectAnonymousMessage: {
      background: colors.navBarBackground,
      padding: '0rem 1rem',
      boxShadow: Shadow.ONE,
      overflow: 'auto',
      marginTop: '1rem',
    },
    ReconnectAnonymousMessageMobile: {
      textAlign: 'center',
    },
    closeButton: {
      position: 'absolute',
      top: 6,
      right: 24,
    },
    buttonContainerReconnectMessage: {
      display: 'flex',
      padding: '1rem',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'baseline',
    },
    ReconnectHeaderStyleMob: {
      textAlign: 'center',
    },
    buttonContainerReconnectMessageMobile: {
      display: 'flex',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      justifyContent: 'center',
      alignContent: 'center',
    },
    reconnectPopupCallButton: {
      fontSize: '1rem',
      borderRadius: 5,
      color: colors.white,
      width: '130px',
      background: colors.orange,
      letterSpacing: 0.32,
      marginLeft: '1rem',
      boxShadow: `0px 5px 5px ${colors.boxShadowColor}`,
      '&:hover': {
        boxShadow: theme.shadows[5],
        background: colors.orange,
      },
    },
    cancelButton: {
      color: colors.brightBlue,
      textAlign: 'center',
      textDecoration: 'underline',
    },
    reconnectPopupCallButtonMobile: {
      fontSize: '1rem',
      borderRadius: 18,
      color: colors.white,
      width: '130px',
      background: colors.orange,
      marginBottom: '1rem',
      letterSpacing: 0.32,
      boxShadow: `0px 5px 5px ${colors.boxShadowColor}`,
      '&:hover': {
        boxShadow: theme.shadows[5],
        background: colors.orange,
      },
    },
  }),
);

interface ShowReconnectPopupProps {
  onClose: () => void;
}

export default function ReconnectPopup({ onClose }: ShowReconnectPopupProps) {
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <BottomDrawerLayout
          onClose={onClose}
          data-testid={'notification-options'}
          refId={6}
          defaultSnap={DrawerSnapType.default}
        >
          <ShowData onClose={onClose} />
        </BottomDrawerLayout>
      ) : (
        <Modal
          open={true}
          onClose={onClose}
          disableAutoFocus
          disableEnforceFocus
          disableRestoreFocus
        >
          <div className={classes.modalWrapper}>
            {<ShowData onClose={onClose} />}
          </div>
        </Modal>
      )}
    </>
  );
}
const ShowData = ({ onClose }: ShowReconnectPopupProps) => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const { t, richT } = useTranslation();
  const customerCareNumber = t('CUSTOMER_CARE_NUMBER_OTHER');
  return (
    <div
      className={
        !isMobile
          ? classes.reconnectPopupStyles
          : classes.reconnectPopupStylesMobile
      }
    >
      <div>
        <div className={classes.closeButton}>
          <IconButton
            hidden={isMobile}
            aria-label="close"
            color="inherit"
            onClick={onClose}
            data-testid="close-icon"
          >
            <Close />
          </IconButton>
        </div>
        <div className={!isMobile ? '' : classes.ReconnectHeaderStyleMob}>
          <Typography variant={'h3'}>
            {t('RECONNECT_MESSAGE_TITLE_ANONYMOUS_FLOW')}
          </Typography>
        </div>
        <div
          className={
            !isMobile
              ? classes.ReconnectAnonymousMessage
              : classes.ReconnectAnonymousMessageMobile
          }
        >
          <Typography variant={'subtitle1'}>
            {richT('RECONNECT_MESSAGE_ANONYMOUS_FLOW_CONTENT')}
          </Typography>
        </div>
        <div
          className={
            !isMobile
              ? classes.buttonContainerReconnectMessage
              : classes.buttonContainerReconnectMessageMobile
          }
        >
          <div>
            <Button
              className={classes.cancelButton}
              disableRipple={true}
              onClick={onClose}
            >
              <Typography variant={'h4'} noWrap>
                {t('CLOSE')}
              </Typography>
            </Button>
          </div>
          <div>
            <Button
              aria-label="reconnect-popup-close"
              className={
                !isMobile
                  ? classes.reconnectPopupCallButton
                  : classes.reconnectPopupCallButtonMobile
              }
              onClick={onClose}
            >
              <Typography>
                {
                  <a
                    href={'tel:' + customerCareNumber}
                    style={{
                      textDecoration: 'none',
                      color: colors.white,
                      fontSize: 'smaller',
                    }}
                  >
                    {' '}
                    {customerCareNumber}
                  </a>
                }
              </Typography>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
